function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { identityFn, wrapActionForIntercept } from './utils';
import createDepObject from './createDepObject';
import execProcessFn from './execProcessFn';
import createDispatch from './createDispatch';
import createCancelled$ from './createCancelled$';
var debug = function debug(/* ...args */) {};
export default function createLogicAction$(_ref) {
  var _Observable$create;
  var action = _ref.action,
    logic = _ref.logic,
    store = _ref.store,
    deps = _ref.deps,
    cancel$ = _ref.cancel$,
    monitor$ = _ref.monitor$,
    action$ = _ref.action$;
  var getState = store.getState;
  var name = logic.name,
    processFn = logic.process,
    dispatchReturn = logic.processOptions.dispatchReturn;
  var intercept = logic.validate || logic.transform; // aliases

  debug('createLogicAction$', name, action);
  monitor$.next({
    action: action,
    name: name,
    op: 'begin'
  }); // also in logicWrapper

  var logicActionOps = [cancel$ ? takeUntil(cancel$) : null,
  // only takeUntil if cancel or latest
  take(1)].filter(identityFn);

  // logicAction$ is used for the mw next(action) call
  var logicAction$ = (_Observable$create = Observable.create(function (logicActionObs) {
    // create notification subject for process which we dispose of
    // when take(1) or when we are done dispatching
    var _createCancelled$ = createCancelled$({
        action: action,
        cancel$: cancel$,
        monitor$: monitor$,
        logic: logic
      }),
      cancelled$ = _createCancelled$.cancelled$,
      setInterceptComplete = _createCancelled$.setInterceptComplete;
    var _createDispatch = createDispatch({
        action: action,
        cancel$: cancel$,
        cancelled$: cancelled$,
        logic: logic,
        monitor$: monitor$,
        store: store
      }),
      dispatch = _createDispatch.dispatch,
      dispatch$ = _createDispatch.dispatch$,
      done = _createDispatch.done;

    // passed into each execution phase hook as first argument
    var ctx = {}; // for sharing data between hooks
    var depObj = createDepObject({
      deps: deps,
      cancelled$: cancelled$,
      ctx: ctx,
      getState: getState,
      action: action,
      action$: action$
    });
    function shouldDispatch(act, useDispatch) {
      if (!act) {
        return false;
      }
      if (useDispatch === 'auto') {
        // dispatch on diff type
        return act.type !== action.type;
      }
      return useDispatch; // otherwise forced truthy/falsy
    }
    var AllowRejectNextDefaults = {
      useDispatch: 'auto'
    };
    function applyAllowRejectNextDefaults(options) {
      return _objectSpread(_objectSpread({}, AllowRejectNextDefaults), options);
    }
    function allow(act) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AllowRejectNextDefaults;
      handleNextOrDispatch(true, act, options);
    }
    function reject(act) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AllowRejectNextDefaults;
      handleNextOrDispatch(false, act, options);
    }
    function handleNextOrDispatch(shouldProcess, act, options) {
      var shouldProcessAndHasProcessFn = shouldProcess && processFn;
      var _applyAllowRejectNext = applyAllowRejectNextDefaults(options),
        useDispatch = _applyAllowRejectNext.useDispatch;
      if (shouldDispatch(act, useDispatch)) {
        monitor$.next({
          action: action,
          dispAction: act,
          name: name,
          shouldProcess: shouldProcess,
          op: 'nextDisp'
        });
        setInterceptComplete();
        dispatch(wrapActionForIntercept(act), {
          allowMore: true
        }); // will be completed later
        logicActionObs.complete(); // dispatched action, so no next(act)
      } else {
        // normal next
        if (act) {
          monitor$.next({
            action: action,
            nextAction: act,
            name: name,
            shouldProcess: shouldProcess,
            op: 'next'
          });
        } else {
          // act is undefined, filtered
          monitor$.next({
            action: action,
            name: name,
            shouldProcess: shouldProcess,
            op: 'filtered'
          });
          setInterceptComplete();
        }
        postIfDefinedOrComplete(act, logicActionObs);
      }

      // unless rejected, we will process even if allow/next dispatched
      if (shouldProcessAndHasProcessFn) {
        // processing, was an accept
        // if action provided is empty, give process orig
        depObj.action = act || action;
        execProcessFn({
          depObj: depObj,
          dispatch: dispatch,
          done: done,
          processFn: processFn,
          dispatchReturn: dispatchReturn,
          dispatch$: dispatch$,
          name: name
        });
      } else {
        // not processing, must have been a reject
        dispatch$.complete();
      }
    }

    /* post if defined, then complete */
    function postIfDefinedOrComplete(act, act$) {
      if (act) {
        act$.next(act); // triggers call to middleware's next()
      }
      setInterceptComplete();
      act$.complete();
    }

    // start use of the action
    function start() {
      // normal intercept and processing
      return intercept(depObj, allow, reject);
    }
    start();
  })).pipe.apply(_Observable$create, _toConsumableArray(logicActionOps)); // take, takeUntil

  return logicAction$;
}